import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownItem } from 'reactstrap';
import './index.scss';

const DrodpdownEntry = ({ _handleClick, value }) => {

	const [dropdownOpen, setDropdownOpen] = useState(false);

	useEffect(() => {
		const scrollElem = document.getElementById('paginationBlc');
		const scrollElem2 = document.querySelector('.right-wrapper');

		scrollElem.addEventListener('scroll', () => {
			setDropdownOpen(false)
		})
		scrollElem2.addEventListener('scroll', () => {
			setDropDownWidth();
		})
	}, [dropdownOpen])

	const setDropDownWidth = () => {
		// Initilize Item
		const toggleBtnElem = document.getElementById('entryToggleBtn');
		if (toggleBtnElem) {
			const toggleBtnElemWidth = toggleBtnElem.offsetWidth;
			const dropDownMenuElem = document.getElementById('entrysDropDownMenu');

			// set Item position
			const toggleBtnPos = toggleBtnElem.getBoundingClientRect();
			dropDownMenuElem.style.left = toggleBtnPos.x + "px";
			dropDownMenuElem.style.top = toggleBtnPos.y + "px";
			dropDownMenuElem.style.width = toggleBtnElemWidth + 'px';
		}
	}
	const toggle = () => {
		setDropdownOpen(prevState => !prevState);
		setDropDownWidth();
	}

	return (<>

		<select className='form-select dropdown-entry col-cell w-auto' onChange={(val) => { _handleClick(val.target.value) }} value={value}>
			<option value="2">10</option>
			<option value="4">20</option>
			<option value="6">30</option>
		</select></>
	);
}

export default DrodpdownEntry;